import { Flex, FlexProps, Text } from '@chakra-ui/react'
import React, { ForwardedRef, ReactNode, useMemo } from 'react'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

type GroupedScrollingListHeaderProps = FlexProps & {
  text?: string | ReactNode
  index?: number
  children?: ReactNode
  onClick?: () => void
}

export const GroupedScrollingListHeader = React.forwardRef<
  HTMLDivElement,
  GroupedScrollingListHeaderProps
>(
  (
    props: GroupedScrollingListHeaderProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const { text, index, children, onClick, ...rest } = props

    const contentIsText =
      (children && typeof children === 'string') ||
      (text && typeof text === 'string')

    const contentValue = useMemo(() => {
      const content = children ?? text

      if (contentIsText) {
        return <Text {...textStyles[textStyleKeys.Body4_Bold]}>{content}</Text>
      }

      return content
    }, [text, children])
    return (
      <Flex
        ref={ref}
        key={index}
        width="100%"
        height="1rem"
        px=".75rem"
        borderRadius=".25rem"
        alignItems="center"
        fontWeight="bold"
        onClick={onClick}
        bg="bg.emphasized"
        {...rest}
      >
        {contentValue}
      </Flex>
    )
  },
)
